import { useMutation } from '@tanstack/react-query';

import {
  AdminFonctionnelControllerApi,
  DossierDtoAdminFonctionnel,
  DossierResponseDto,
  UpdateDonneesJudiciairesRequestDto,
} from 'lib_api/lib/api/gen';

import { backAlertMessage } from '../utils/backAlertMessage';

import {
  ControllerApi,
  SetDossierAdminF,
  SetDossierFo,
  SubmitFunction,
  UpdateDonneesJudiciairesFormValues,
} from './types';
import { buildUpdateDonneesJudiciairesDto } from './utils';

function useSubmitUpdateDonneesJudiciaires(
  controller: ControllerApi,
  dossierId: string,
  setDossier: SetDossierFo | SetDossierAdminF,
  closeModal: () => void,
): SubmitFunction {
  const mutation = useMutation<
    DossierDtoAdminFonctionnel | DossierResponseDto,
    Response,
    UpdateDonneesJudiciairesFormValues
  >({
    mutationFn: (values: UpdateDonneesJudiciairesFormValues) => {
      const updatedDatas: UpdateDonneesJudiciairesRequestDto =
        buildUpdateDonneesJudiciairesDto(values);

      return getUpdateDonneesJudiciaires(controller)(dossierId, updatedDatas);
    },
    onSuccess: (result: DossierDtoAdminFonctionnel | DossierResponseDto) => {
      setDossier(result as DossierDtoAdminFonctionnel & DossierResponseDto);
      closeModal();
    },
    onError: (error: Response) => {
      void backAlertMessage(error);
    },
    mutationKey: ['update-donnees-judiciaires', dossierId],
  });

  return {
    submit: async (values: UpdateDonneesJudiciairesFormValues) => {
      await mutation.mutateAsync(values);
    },
    inProgress: mutation.isPending,
  };
}

export function isInstanceOfAdminFonctionnel(
  controller: ControllerApi,
): controller is AdminFonctionnelControllerApi {
  return controller instanceof AdminFonctionnelControllerApi;
}

function getUpdateDonneesJudiciaires(controller: ControllerApi) {
  if (isInstanceOfAdminFonctionnel(controller)) {
    return controller.updateDonneesJudiciairesUsingPOST1.bind(controller);
  }
  return controller.updateDonneesJudiciairesUsingPOST.bind(controller);
}

export default useSubmitUpdateDonneesJudiciaires;
